/* eslint-disable no-constant-condition */
import { useCallback } from 'react'
import fetchHelper, { deleteAuthToken } from 'library/FetchHelper'
import { API_ASDI_CMS_BASE_URL } from 'config/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useWalletModal } from '@pancakeswap/uikit'
import useAuth from 'hooks/useAuth'
import { useTranslation } from 'contexts/Localization'
import useToast from 'hooks/useToast'
import { setGetNameSevice } from 'hooks/setGetNameService'
import { setUserInfo } from '../actions'

export const useGetProfileUser = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { toastError }: any = useToast()

  const { isLogin } = useSelector((state: any) => state.auth)

  const { login, logout } = useAuth()
  const { onPresentConnectModal } = useWalletModal(login, logout, t)

  const getData = useCallback(async () => {
    try {
      if (isLogin) {
        fetchHelper
          .fetch(`${API_ASDI_CMS_BASE_URL}/profile`, {
            method: 'GET',
          })
          .then(async ([resp, status]: any) => {
            if (status === 200) {
              const dataInfo = {
                ...resp.data,
                nameSevice: await setGetNameSevice(resp.data.walletAddress),
              }

              dispatch(
                setUserInfo({
                  data: dataInfo,
                }),
              )
            } else if (status === 401) {
              logout()
              deleteAuthToken()
              onPresentConnectModal()
              toastError('Login session has expired')
            }
          })
      }
    } catch (error) {
      console.error('useGetProfileUser', error)
      toastError(error)
    }
  }, [dispatch, isLogin, logout, onPresentConnectModal, toastError])

  return [getData]
}
